export default "__VITE_ASSET__CN9RJXBq__"